'use strict';

import { renderFragment, remove } from 'lilly/domUtil';
const { quickView: quickViewTemplates } = require('../templates');
const { injectAfterpay, injectFitPredictor, updateFullProductLink } = require('../quickView/quickViewHelpers').default;
const { getJSON } = require('../util');
const $body = $('body');

/**
 * Generates the modal window on the first call.
 * @param {HTMLElement} srcElement - quick view initiator element
 */
function getModalHtmlElement(srcElement) {
    const quickViewModalEl = document.getElementById('quickViewModal');
    remove(quickViewModalEl);
    const quickview = renderFragment(quickViewTemplates.quickViewModal);
    quickview.firstElementChild.dataset.srcElement = srcElement;
    document.body.append(quickview);
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {boolean} isStyliticsGallery - determine if it is Stylitycs Gallery on PLP
 */
function fillModalElement(selectedValueUrl, isStyliticsGallery) {
    const quickViewModal = $('#quickViewModal');

    $.spinner().start();

    getJSON(
        selectedValueUrl,
        'GET',
        null,
        data => {
            const { quickviewProductInfo } = data;
            const parsedHtml = renderFragment(data.renderedTemplate);

            if (quickViewModal) {
                quickViewModal.find('.modal-body').html(parsedHtml);
                quickViewModal.find('.size-chart').attr('href', data.productUrl);
                quickViewModal.find('.enter-message').text(data.enterDialogMessage);

                updateFullProductLink(data.quickViewFullDetailMsg, data.productUrl, quickViewModal);
                injectAfterpay(quickViewModal);
                injectFitPredictor(quickViewModal);

                if (quickviewProductInfo) {
                    window.quickviewProductInfo = quickviewProductInfo;
                    const swatchEl = quickViewModal.find('.color-attribute .swatch-value');
                    const selectedSwatchEl = quickViewModal.find('.color-attribute .swatch-value.selected');
                    const sizeElements = quickViewModal.find('.size-btn');
                    if (quickviewProductInfo && swatchEl.length && !selectedSwatchEl) {
                        quickViewModal.find('.color-attribute').eq(0).click();
                    }
                    if (selectedSwatchEl && sizeElements.length === 1 && !sizeElements.hasClass('selected')) {
                        sizeElements.click();
                    }
                }

                quickViewModal.modal('show');

                requestAnimationFrame(() => {
                    $body.trigger('quickview:visible');
                });

                // add class 'is-stylitics-gallery' if it is Stylititcs Gallery on PLP
                if (isStyliticsGallery) quickViewModal.find('.product-detail')?.addClass('is-stylitics-gallery');
            }

            $.spinner().stop();
        },
        () => $.spinner().stop()
    );
}

function showQuickview(element, quickViewURL, isStyliticsGallery) {
    if (!quickViewURL || !element) return;

    const srcElement = $(element);
    getModalHtmlElement(srcElement);
    fillModalElement(quickViewURL, isStyliticsGallery);
    srcElement.trigger('quickview:show');
}

export default {
    showQuickview
}
